// extracted by mini-css-extract-plugin
export default {"container":"BlockInfo_container__cVPxV","row":"BlockInfo_row__-rNut","icon":"BlockInfo_icon__or52Q","label":"BlockInfo_label__hUAsA","value":"BlockInfo_value__BYk6u"};